import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  public errorMessage: string = '';


  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]], // Assuming the username is an email
      password: ['', [Validators.required]]
    });
  }

  onSubmit(): void {
    if (this.loginForm.invalid) {
      return;
    }
  
    const { email, password } = this.loginForm.value;
    this.authService.login(email, password).subscribe({
      next: (response) => {
        localStorage.setItem('token', response.token); // Store the token
        this.router.navigate(['/']); // Adjust this to where you want users to go post-login
        
      },
      error: (error) => {
        console.error('Login failed:', error);
        this.errorMessage = error.error.message || "An error occurred during login."; // Adjust based on your error structure

        if (error.status === 401 && error.error.message === "User has not verified their email.") {
          // Route to account verification page, passing the email for convenience
          this.router.navigate(['/account-verification'], { queryParams: { email } });
        } else {
          // Handle other errors or display a generic error message
        }
      }
    });
  }
  
  
}
